export function initSiteFooter() {
    const root = document.getElementById('siteFooter');
}
